import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import Text from '@atlaskit/primitives/text';
import { xcss } from '@atlaskit/primitives/xcss';
import Lozenge from '@atlaskit/lozenge/new';

import { NO_DATA_PLACEHOLDER } from '../common/AnalyticsTable/index.ts';

const i18n = defineMessages({
	engagedLozengeLabel: {
		id: 'confluence-analytics.engagement-cell.engaged',
		defaultMessage: 'Engaged',
		description:
			'Label for the lozenge displayed in the engagement cell of the page views table when a user has met engagement criteria with a content piece.',
	},
	briefLozengeLabel: {
		id: 'confluence-analytics.engagement-cell.brief',
		defaultMessage: 'Brief',
		description:
			'Label for the lozenge displayed in the engagement cell of the page views table when a user has not met engagement criteria with a content piece.',
	},
});

const EngagementCellStyles = xcss({
	paddingLeft: 'space.500',
});

type EngagementCellProps = {
	lastViewDate?: string;
	isEngaged?: boolean | null;
};

export const EngagementCell = ({
	isEngaged,
	lastViewDate,
}: EngagementCellProps): React.JSX.Element => {
	if (!lastViewDate) {
		return (
			<Box xcss={EngagementCellStyles} testId="engagement-cell">
				<Text color="color.text.disabled">{NO_DATA_PLACEHOLDER}</Text>
			</Box>
		);
	}

	return (
		<Box xcss={EngagementCellStyles} testId="engagement-cell">
			<Lozenge appearance={isEngaged ? 'information' : 'warning'}>
				<FormattedMessage {...(isEngaged ? i18n.engagedLozengeLabel : i18n.briefLozengeLabel)} />
			</Lozenge>
		</Box>
	);
};
